module.exports = __webpack_public_path__ + "static/media/screenshot-strategic.67fcb04e.png";